import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Palette, Wrench, Rocket } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: FileText,
      title: "Plan (Day 0–2)",
      description: "Quick audit, product list, and launch roadmap.",
      color: "#3b82f6"
    },
    {
      icon: Palette,
      title: "Design (Day 3–6)",
      description: "Creative mockups (tested templates) with speed-first build.",
      color: "#8b5cf6"
    },
    {
      icon: Wrench,
      title: "Build & Upload (Day 7–12)",
      description: "We build the store and start product uploads — you review.",
      color: "#f59e0b"
    },
    {
      icon: Rocket,
      title: "Launch & Support (Day 13–15+)",
      description: "Go live, final QA, plus extended product upload support and 30 days of post-launch help.",
      color: "#10b981"
    }
  ];

  return (
    <section id="process" className="section" style={{ background: 'white' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px'
          }}>
            Our 4-Step Process
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            From planning to launch in just 15 days
          </p>
        </motion.div>

        <div style={{ position: 'relative' }}>
          {/* Connection line */}
          <div style={{
            position: 'absolute',
            top: '60px',
            left: '0',
            right: '0',
            height: '2px',
            background: 'linear-gradient(90deg, #e2e8f0 0%, #667eea 50%, #e2e8f0 100%)',
            zIndex: 1
          }} />

          <div className="grid grid-4">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
                className="card"
                style={{
                  textAlign: 'center',
                  position: 'relative',
                  zIndex: 2,
                  background: 'white',
                  border: '2px solid #f1f5f9'
                }}
              >
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}dd 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px',
                  boxShadow: `0 8px 25px ${step.color}40`,
                  position: 'relative'
                }}>
                  <step.icon size={48} color="white" />
                  
                  {/* Step number */}
                  <div style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-8px',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '700',
                    color: step.color,
                    border: `2px solid ${step.color}`
                  }}>
                    {index + 1}
                  </div>
                </div>
                
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '12px'
                }}>
                  {step.title}
                </h3>
                
                <p style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: '1.6'
                }}>
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
